import React, { useEffect, useMemo, useState } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  MenuItem,
  Switch,
  TextField,
} from '@mui/material'
import { states } from '../../../register/states'
import useAlert from '../../../hooks/useAlert'

const EditLocationModal = ({
  onSave,
  onCancel,
  open,
  location,
  isNew,
  isFirst,
  deleteLocation,
}) => {
  const EMPTY_LOCATION = useMemo(
    () => ({
      name: '',
      streetAddress: '',
      city: '',
      stateOrProvince: '',
      country: 'US',
      isDefault: isFirst,
    }),
    [isFirst]
  )

  const [localCopy, setLocalCopy] = useState(
    !isNew && location ? JSON.parse(JSON.stringify(location)) : EMPTY_LOCATION
  )

  useEffect(() => {
    setLocalCopy(
      !isNew && location ? JSON.parse(JSON.stringify(location)) : EMPTY_LOCATION
    )
  }, [isNew, location])

  const updateLocalCopy = (key, e) => {
    setLocalCopy({ ...localCopy, [key]: e.target.value })
  }

  const getAddressQuery = (cl) => {
    if (!cl) return ''
    return `${cl.streetAddress} ${cl.city}, ${
      cl.stateOrProvince ? cl.stateOrProvince + ', ' : ''
    } ${cl.country}`
  }

  const { createAlert } = useAlert()

  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>
        {isNew
          ? 'New location'
          : `Editing location: ${location?.name || getAddressQuery(location)}`}
      </DialogTitle>
      <DialogContent>
        <TextField
          fullWidth
          value={localCopy.name}
          label='Location name (optional)'
          onChange={(e) => updateLocalCopy('name', e)}
          margin='dense'
        />

        <TextField
          fullWidth
          value={localCopy.streetAddress}
          label='Street Address'
          onChange={(e) => updateLocalCopy('streetAddress', e)}
          margin='dense'
        />

        <TextField
          fullWidth
          value={localCopy.city}
          label='City'
          onChange={(e) => updateLocalCopy('city', e)}
          margin='dense'
        />

        <TextField
          fullWidth
          value={localCopy.stateOrProvince}
          label='State'
          onChange={(e) => updateLocalCopy('stateOrProvince', e)}
          margin='dense'
        >
          {states.map((s) => (
            <MenuItem key={s} value={s}>
              {s}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          fullWidth
          value={localCopy.zipCode}
          label='Zip Code'
          onChange={(e) => updateLocalCopy('zipCode', e)}
          margin='dense'
        />

        <FormControlLabel
          label={'Is primary location'}
          control={
            <Switch
              checked={localCopy.isDefault}
              onChange={(e) =>
                setLocalCopy({
                  ...localCopy,
                  isDefault: e.target.checked,
                })
              }
            />
          }
        ></FormControlLabel>
      </DialogContent>
      <DialogActions>
        {!isNew && (
          <Button
            color='warning'
            onClick={() => {
              deleteLocation(location).then(() => {
                onCancel()
                setTimeout(() => {
                  createAlert({ message: 'Successfully deleted location' })
                }, 50)
              })
            }}
          >
            Delete
          </Button>
        )}

        <div style={{ flex: '1 0 0' }} />
        <Button onClick={onCancel}>Cancel</Button>
        <Button
          color='primary'
          variant='contained'
          onClick={() => onSave(localCopy)}
        >
          Done
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default EditLocationModal
